import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaLock,
  FaUserShield,
  FaCookieBite,
  FaLink,
  FaSyncAlt,
  FaEnvelope,
} from "react-icons/fa";

const PrivacyPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const sections = [
    {
      icon: <FaUserShield size={28} className="text-success me-3" />,
      title: "1. Information We Collect",
      text: "We may collect personal information such as your name, email address, phone number, and other relevant details when you contact us or use our services.",
      animation: "fade-right",
    },
    {
      icon: <FaLock size={28} className="text-success me-3" />,
      title: "2. How We Use Your Information",
      text: "Your information is used to provide and improve our services, communicate with you, and comply with legal obligations. We do not sell or share your personal data with third parties for marketing purposes.",
      animation: "fade-left",
    },
    {
      icon: <FaLock size={28} className="text-success me-3" />,
      title: "3. Data Security",
      text: "We take appropriate security measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction.",
      animation: "fade-right",
    },
    {
      icon: <FaCookieBite size={28} className="text-success me-3" />,
      title: "4. Cookies and Tracking Technologies",
      text: "Our website may use cookies to enhance user experience. You can choose to disable cookies through your browser settings.",
      animation: "fade-left",
    },
    {
      icon: <FaLink size={28} className="text-success me-3" />,
      title: "5. Third-Party Links",
      text: "Our website may contain links to third-party sites. We are not responsible for their privacy practices and encourage you to review their policies.",
      animation: "fade-right",
    },
    {
      icon: <FaSyncAlt size={28} className="text-success me-3" />,
      title: "6. Changes to This Policy",
      text: "We reserve the right to update this Privacy Policy at any time. Any changes will be posted on this page.",
      animation: "fade-left",
    },
    {
      icon: <FaEnvelope size={28} className="text-success me-3" />,
      title: "7. Contact Us",
      text: (
        <>
          If you have any questions about this Privacy Policy, please contact us
          at{" "}
          <a
            href="mailto:info@integrity-mt.com"
            className="text-success fw-bold"
          >
            info@integrity-mt.com
          </a>
          .
        </>
      ),
      animation: "fade-right",
    },
  ];

  return (
    <div className="privacy-page py-5 position-relative overflow-hidden">
      <div className="bg-gradient position-absolute w-100 h-100 top-0 start-0"></div>

      <div className="container position-relative z-2">
        <div className="text-center mb-5" data-aos="zoom-in">
          <h1 className="display-3 fw-bold text-white mb-3">Privacy Policy</h1>
          <p className="fs-5 text-light">
            Your privacy is our priority. Learn how we handle your information.
          </p>
        </div>

        <div className="row g-4">
          {sections.map((section, idx) => (
            <div className="col-md-6" key={idx} data-aos={section.animation}>
              <div className="card shadow-lg h-100 border-0 hover-card p-4">
                <div className="d-flex align-items-center mb-3">
                  {section.icon}
                  <h3 className="fw-bold text-success mb-0">{section.title}</h3>
                </div>
                <p className="text-dark fs-6">{section.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .privacy-page {
          background: linear-gradient(135deg, #0d5325 0%, #077325 100%);
          min-height: 100vh;
        }

        .bg-gradient {
          background: radial-gradient(
              circle at top left,
              rgba(255, 255, 255, 0.05),
              transparent 70%
            ),
            radial-gradient(
              circle at bottom right,
              rgba(0, 0, 0, 0.05),
              transparent 70%
            );
          z-index: 0;
        }

        .hover-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 15px;
          background: rgba(255, 255, 255, 0.95);
        }
        .hover-card:hover {
          transform: translateY(-10px) scale(1.03);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
        }

        h1.display-3 {
          letter-spacing: 3px;
          text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        }

        .card h3 {
          position: relative;
        }
        .card h3::after {
          content: "";
          display: block;
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, #0d5325, #077325, #0d5325);
          border-radius: 2px;
          margin-top: 5px;
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;
